import React, { useState, useEffect, useContext } from "react";
import { FormGroup, Label } from "reactstrap";
import { FocusedNodeContext } from "../../Service/Context/FocusedNode";

export default ({
  name,
  finishCallback,
  value,
  onChange,
  disabled,
  placeholder,
  style,
  onFocus,
  index,
  patchField,
  onBlur,
  big,
  inlinePlaceholder,
}) => {
  const [ref] = useState(React.createRef());
  const [fieldValue, setFieldValue] = useState(value);
  const [internValue, setInternValue] = useState(value);
  const { setFocusedNode, setListPosition } = useContext(FocusedNodeContext);

  useEffect(() => {
    if (typeof value === "string") {
      if (value !== internValue) {
        if (value !== null) {
          setFieldValue(value);
          setInternValue(value);
        }
      }
    } else if (typeof value === "object") {
      console.error("value in DivInputField was" + value);
    } else {
      console.error("typeof value in DivInputField was", typeof value);
    }
  });

  if (value == null) {
    value = "";
  }

  let opts = {};
  if (disabled === "disabled") {
    opts["disabled"] = true;
  }

  let styles = {
    inputContainer: {
      ...style,
    },
    inputField: {
      minHeight: big ? 250 : 34,
      height: big ? "100%" : "unset",
    },
  };

  function focusNode(e) {
    setFocusedNode(e.target);
    setListPosition(index);

    if (typeof onFocus === "function") {
      onFocus(e);
    }
  }

  function sanitizePastedHtml(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const sanitizeNode = (node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) {
        return;
      }

      if (node.tagName === "FONT") {
        const parent = node.parentNode;

        while (node.firstChild) {
          parent.insertBefore(node.firstChild, node);
        }

        parent.removeChild(node);
        return;
      }

      if (node.hasAttribute("face")) {
        node.removeAttribute("face");
      }

      if (node.hasAttribute("style")) {
        const style = node.style;
        style.removeProperty("font");
        style.removeProperty("font-family");
        style.removeProperty("font-size");
        style.removeProperty("font-style");
        style.removeProperty("font-variant");
        style.removeProperty("font-weight");
        style.removeProperty("line-height");

        if (!node.getAttribute("style")?.trim()) {
          node.removeAttribute("style");
        }
      }

      Array.from(node.childNodes).forEach(sanitizeNode);
    };

    Array.from(doc.body.childNodes).forEach(sanitizeNode);

    return doc.body.innerHTML;
  }

  function insertHtmlAtCursor(html) {
    document.execCommand("insertHTML", false, html);
  }

  return (
    <FormGroup style={styles.inputContainer}>
      <div
        contentEditable={true}
        style={styles.inputField}
        className="form-control"
        {...opts}
        ref={ref}
        onFocus={focusNode}
        onInput={(e) => {
          setInternValue(e.target.innerHTML);
          onChange(e.target.innerHTML, name);
        }}
        onPaste={(e) => {
          e.preventDefault();

          const html = e.clipboardData.getData("text/html");
          const text = e.clipboardData.getData("text/plain");
          const sanitizedValue = html
            ? sanitizePastedHtml(html)
            : text.replace(/\n/g, "<br>");

          insertHtmlAtCursor(sanitizedValue);

          const updatedValue = e.currentTarget.innerHTML;
          setInternValue(updatedValue);
          onChange(updatedValue, name);
        }}
        onBlur={(e) => {
          finishCallback({ [patchField]: e.currentTarget.innerHTML });
        }}
        name={name}
        dangerouslySetInnerHTML={{ __html: fieldValue }}
        placeholder={inlinePlaceholder ? inlinePlaceholder : undefined}
      ></div>
      {placeholder !== undefined && (
        <Label className={"textarea"} for={name} sm={12}>
          {placeholder}
        </Label>
      )}
    </FormGroup>
  );
};

